<template>
    <div :class="$style.container"
         id="loading"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">

            <el-row>
                <el-col :span="12">
                    <div style="font-size: 22px;padding: 20px;padding-top: 28px">
                        客户变更审批
                    </div>
                </el-col>
                <el-col :span="12">
                    <div style="padding: 20px;padding-top: 28px;float: right" class="people">
                        <el-form ref="form" :model="form" label-width="80px">
                            <el-form-item label="管理辖区">
                                <el-select v-model="form.UserList" placeholder="请选择">
                                    <el-option
                                            v-for="item in UserList"
                                            :key="item.user_id"
                                            :label="item.user_name"
                                            :value="item.user_id"
                                            :disabled="role=='staff'"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-col>
            </el-row>

                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <!--<div class="swiper-slide">-->
                           <!--<el-row style="padding: 10px">-->
                             <!--<el-col :span="12"><span>上海1（E-SHA-01）</span></el-col>-->
                             <!--<el-col :span="12"><span style="float: right;color: #FF9901">9月</span></el-col>-->
                           <!--</el-row>-->

                            <!--<el-row style="padding:0 10px">-->
                                <!--<el-col :span="4"><span style="border: 1px solid #FF9901;background-color: #FF9901;color: #fff;font-size: 11px;border-radius:3px">王晓云</span></el-col>-->
                                <!--<el-col :span="20"><span style="color: #B0B5B9;font-size: 9px">职务：SMR    入职时间：2015年7月1日</span></el-col>-->
                            <!--</el-row>-->

                            <!--<el-row style="padding:15px 0 0 10px">-->
                                <!--<el-col :span="8"><span>指标：300</span></el-col>-->
                                <!--<el-col :span="8"><span>预估：<span style="background-color: #ff9901;border: 1px solid #ff9901;color: #fff;border-radius: 3px;font-size: 11px;padding: 0 5px">300</span></span></el-col>-->
                                <!--<el-col :span="8"><span>达成率：<span style="color:#7ED321 ">100</span><span style="color: #fff;background-color: #9b9b9b;border-radius: 3px;padding: 0 3px;margin-left: 5px">%</span> </span></el-col>-->
                            <!--</el-row>-->

                            <!--<el-row style="padding: 10px 0 0 10px">-->
                                <!--<el-col :span="8"><span>实际销售：<span style="color: #4A90E2">暂无</span> </span></el-col>-->
                                <!--<el-col :span="8"><span>去年同期：<span  style="color: #4A90E2">300</span></span></el-col>-->
                                <!--<el-col :span="8"><span>增长率：<span  style="color: #4A90E2">N/A</span><span style="color: #fff;background-color: #9b9b9b;border-radius: 3px;padding: 0 3px;margin-left: 5px">%</span> </span></el-col>-->
                            <!--</el-row>-->

                        <!--</div>-->
                        <div class="swiper-slide">
                            <el-row style="padding: 10px">
                                <el-col :span="24"><span style="color: #4D586D;font-size: 14px">上海1（E-SHA-01）</span></el-col>
                            </el-row>

                            <el-row style="padding:0 10px">
                                <el-col :span="4"><span style="border: 1px solid #FF9901;background-color: #FF9901;color: #fff;font-size: 11px;border-radius:3px">王晓云</span></el-col>
                                <el-col :span="20"><span style="color: #B0B5B9;font-size: 9px">职务：SMR    入职时间：2015年7月1日</span></el-col>
                            </el-row>

                            <el-row style="padding:10px 0 0 10px">
                                <el-col :span="4"><span style="color: #4D586D;font-size: 14px">医疗机构</span></el-col>
                                <el-col :span="12"><span style="font-size: 11px;margin-left: 20px;color: #4D586D">已生效目标客户：<span style="color: #81b1ea">182人</span></span></el-col>
                                <el-col :span="8"><span style="font-size: 11px;color: #4D586D">待审批：<span style="color: #81b1ea">5人</span> </span></el-col>
                            </el-row>

                            <el-row style="padding:10px 0 0 10px">
                                <el-col :span="4"><span style="color: #4D586D;font-size: 14px">零售终端</span></el-col>
                                <el-col :span="12"><span style="font-size: 11px;margin-left: 20px;color: #4D586D">已生效目标客户：<span style="color: #81b1ea">2家</span></span></el-col>
                                <el-col :span="8"><span style="font-size: 11px;color: #4D586D">待审批：<span style="color: #81b1ea">1家</span> </span></el-col>
                            </el-row>

                            <el-row style="padding:10px 0 0 10px">
                                <el-col :span="4"><span style="color: #4D586D;font-size: 14px">医疗机构</span></el-col>
                                <el-col :span="12"><span style="font-size: 11px;margin-left: 20px;color: #4D586D">已生效目标客户：<span style="color: #81b1ea">无</span></span></el-col>
                                <el-col :span="8"><span style="font-size: 11px;color: #4D586D">待审批：<span style="color: #81b1ea">无</span> </span></el-col>
                            </el-row>
                            <span style="position: relative;left: 360px;top: -70px;">
                                <el-checkbox v-model="checked"></el-checkbox>
                            </span>

                        </div>
                        <!--<div class="swiper-slide">Slide 2</div>-->
                        <!--<div class="swiper-slide">Slide 3</div>-->
                        <!--<div class="swiper-slide">Slide 3</div>-->
                        <!--<div class="swiper-slide">Slide 3</div>-->
                        <!--<div class="swiper-slide">Slide 3</div>-->
                    </div>


                    <!-- 如果需要导航按钮 -->
                    <div class="zuo" style="position: relative;top: -80px;left: 20px;width: 20px;float: left">
                        <img src="../../assets/images/zuo.png" alt="">
                    </div>
                    <div class="you"style="float: right;position: relative;top: -80px;width: 20px;right: 20px">
                        <img src="../../assets/images/you.png" alt="">
                    </div>

                    <div class="suo" style="position: relative;top: -20px;float: right">
                        <el-checkbox v-model="checked" style="margin-right: 10px"></el-checkbox><span style="color: #4A90E2;font-size: 14px">选中以上所有终端辖区</span>
                    </div>
                </div>


        <el-row style="margin-top: 45px">
            <el-col :span="8">
                <div style="padding-left: 20px;line-height: 40px;color: #4A90E2">上海1（E-SHA-01）<span style="background-color: #ff9901;color: #fff;font-size: 12px;border: 1px solid #ff9901;padding: 0 2px;border-radius: 3px">王晓云</span></div>
            </el-col>
            <el-col :span="8">
                <div  style="width: 300px;margin: 0 auto">
                    <el-button-group >
                        <el-button @click="dianji">医疗机构</el-button>
                        <el-button  style="color: #409EFF;border-color: #c6e2ff;background-color: #ecf5ff;">零售终端</el-button>
                        <el-button @click="dianji2">分销客户</el-button>
                    </el-button-group>
                </div>
            </el-col>
            <el-col :span="8">
                <div style="float: right;padding-right: 20px">
                    <el-button type="success" size="small" icon="el-icon-circle-check">同意</el-button>
                    <el-button type="danger" size="small" icon="el-icon-circle-close">拒绝</el-button>
                </div>
            </el-col>
        </el-row>

        <el-row>
            <el-col :span="24" style="padding:15px 20px 20px 20px">
                <div style="border: 1px dashed #ededed">

                </div>
            </el-col>
        </el-row>

        <el-row style="padding:0px 20px" >
            <el-table
                    :data="tableData"
                    border
                    stripe
                    header-cell-class-name="headerStyle2"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
            >
                <el-table-column
                        type="selection"
                        width="55">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="tempname"
                        label="客户"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="reference_name"
                        label="类型"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="segment_name"
                        label="客户级别"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.old_segment_name !== scope.row.segment_name">
                            <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span>
                            <span style="color: #4A90E2"> -> </span>
                            <span style="color: #4A90E2">{{scope.row.segment_name}}</span>
                        </div>
                        <div v-else="scope.row.old_segment_name == scope.row.segment_name">
                            <span style="margin-left: 5px; color: #4A90E2">{{scope.row.old_segment_name}}</span><span style="color: #4A90E2">(无变化)</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="account_status"
                        label="目标客户"
                >
                    <template  slot-scope="scope">
                        <div v-if="scope.row.account_status == scope.row.old_account_status">
                            <span style="color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                            <span style="color: #4A90E2" v-else="scope.row.old_account_status=='INACTIVE'">否</span>
                            <span style="color: #4A90E2">(无变化)</span>
                        </div>

                        <div v-else="scope.row.account_status!== scope.row.old_account_status">
                            <span style="margin-left: 5px; color: #4A90E2" v-if="scope.row.old_account_status=='ACTIVE'">是</span>
                            <span style="margin-left: 5px; color: #4A90E2" v-else-if="scope.row.old_account_status=='INACTIVE'">否</span>
                            <span style="color: #4A90E2"> -> </span>
                            <span style="color: #4A90E2" v-if="scope.row.account_status=='ACTIVE'">是</span>
                            <span style="color: #4A90E2" v-else-if="scope.row.account_status=='INACTIVE'">否</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop=" comments"
                        label="变更原因"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="effective_date"
                        label="计划生效"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="created_date"
                        label="变更填写日期"
                >
                </el-table-column>
                <el-table-column label="操作" width="72px" class="myclass">
                    <template slot-scope="scope">
                        <el-button
                                type="warning"
                                size="mini"
                                style="margin-right: 10px;float: left;background-color: #ff9901;border: #ff9901 1px solid;"
                                @click="btn(scope.row)"
                        >详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>






    </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import 'swiper/js/swiper.min.js'
    export default {

        data(){
           return{
               loading:false,
               form:{
                   UserList:'',
                   checked:''
               },
               tableData:[]
           }
        },
        methods:{
            dianji(){
                this.$router.push({path:'/pending'});
            },
            dianji2(){
                this.$router.push({path:'/pending/qudao'});
            },
        },

        computed:{

        },
        mounted(){
            let mySwiper = new Swiper('.swiper-container', {
                slidesPerView:"auto",

                freeMode : true,
//                navigation: {
//                    nextEl: '.swiper-button-next',
//                    prevEl: '.swiper-button-prev',
//                },
            });
        },
        watch:{}
    }
</script>

<style lang="scss" module>
    .container {
        background: white;
        height: 100%;

    }

</style>
<style scoped>
  .people >>> .el-form-item__label{
      font-size: 16px;
      color: #000000;
  }
  .swiper-container{

      width: 100%;
      height: 152px;
      background-color: #fff;

  }
  .swiper-wrapper{
      height: 150px;
      width: 92%;
  }
    .swiper-slide{
        width: 400px ;
        margin-left: 10px;
        background-color: #fff;
        border: 1px solid #ededed;
    }
</style>
<style>
    .headerStyle2 > div {
        font-size: 14px;
        color: #585757;
        font-weight: bold;
    }

    .headerStyle2:nth-last-of-type(2) > div {
        color: #4A90E2;
    }
</style>





// WEBPACK FOOTER //
// src/pages/Approval/lingshou.vue